define('v3/Common/Bindings/Mask.Binding',[
	'knockout',
	'lodash',
	'v3/Common/Services/frontend/Frontend.Service'
], function (ko, _, frontend) {
	ko.bindingHandlers.mask = {
		update: function (el, valueAccessor) {
			var params = ko.unwrap(valueAccessor());
			var mask = ko.unwrap(params.showMask);
			var tiny = ko.unwrap(params.tinyLoader);

			if (_.isBoolean(mask)) {
				frontend.mask[mask ? 'show' : 'hide'](el);
			}

			if (_.isBoolean(tiny)) {
				frontend.loader.tiny[tiny ? 'show' : 'hide'](el);
			}
		}
	};
});
